module.exports = __webpack_public_path__ + "static/Image 43-17f7f7a5596343dc5d408bff857f4f5a.png";